import { Capacitor } from '@capacitor/core';
import { NavigationBar } from '@capgo/capacitor-navigation-bar';

export interface NavigationBarParams {
  /** Colore di sfondo della barra di navigazione. */
  color: string;
  /** Usa icone scure se `true`. */
  darkButtons: boolean;
}

/**
 * Imposta il colore della barra di navigazione su Android.
 * Su iOS non viene eseguita alcuna operazione.
 * @param params Parametri colore e stile.
 */
export async function setNavigationBarColor(
  params: NavigationBarParams,
): Promise<void> {
  if (Capacitor.getPlatform() === 'android' &&
      Capacitor.isPluginAvailable('NavigationBar')) {
    await NavigationBar.setNavigationBarColor(params);
  }
}
